<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar, 'halloween-theme': halloweenActive, 'halloween-dashboard': halloweenActive && $route.path === '/dashboard', 'halloween-command-list': halloweenActive && isCommandListRoute, 'halloween-record-list': halloweenActive && isRecordListRoute }">
    <notifications></notifications>
    <side-bar :background-color="sidebarBackground">
      <button v-if="halloweenEligible" slot="logo-extra" type="button" class="halloween-theme-toggle"
              :aria-label="halloweenEnabled ? 'Désactiver le thème Halloween' : 'Activer le thème Halloween'"
              :aria-pressed="halloweenEnabled ? 'true' : 'false'"
              :title="halloweenEnabled ? 'Revenir au thème classique' : 'Activer le thème Halloween'"
              @click="toggleHalloweenTheme">🎃</button>
      <template slot-scope="props" slot="links">
        <user-menu></user-menu>

        <sidebar-item :link="{ name: 'Tableau de bord', icon: 'fas fa-desktop', path: '/dashboard'}"/>
        <sidebar-item v-if="false" :link="{ name: 'Liste des abonnements', icon: 'fa fa-file-invoice-dollar', path: '/subscriptions/list'}"/>

        <sidebar-item v-if="stateByCommandType !== null" opened :link="{ name: 'Liste des commandes', icon: 'fas fa-th-list'}">
          <sidebar-item
              :filtersNumber="stateByCommandType[3]"
              :link="{
              name: 'Horaflex',
              path: '/commands/Horaflex',
              icon: 'ml-2 fas fa-hospital-symbol',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[2]"
              :link="{
              name: 'Wi-line',
              path: '/commands/WILINE',
              icon: 'ml-2 fas fa-money-bill-wave',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[4]"
              :link="{
              name: 'Speed C.',
              path: '/commands/SpeedControl',
              icon: 'ml-2 fa fa-tachometer-alt',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[5]"
              :link="{
              name: 'Checkbox',
              path: '/commands/checkbox',
              icon: 'ml-2 fa fa-check-square',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[1]"
              :link="{
              name: 'M4',
              path: '/commands/M4',
              icon: 'ml-2 fa fa-hdd',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[6]"
              :link="{
              name: 'Proxy',
              path: '/commands/Proxy',
              icon: 'ml-2 fa fa-server',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[7]"
              :link="{
              name: 'Logiciel',
              path: '/commands/Software',
              icon: 'ml-2 fa fa-window-restore',
            }"></sidebar-item>
          <sidebar-item
              :filtersNumber="stateByCommandType[8]"
              :link="{
              name: 'WIFI',
              path: '/commands/WIFI',
              icon: 'ml-2 fa fa-wifi',
            }"></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{ name: 'Liste des anomalies', icon: 'fas fa-exclamation-triangle', path: '/anomalies/list'}"></sidebar-item>
        <sidebar-item :link="{ name: 'Liste des FNC', icon: 'fas fa-clipboard-list', path: '/fnc/list'}"></sidebar-item>
        <sidebar-item :link="{ name: 'Documentations produits', icon: 'fas fa-qrcode', path: '/product-documentations/list'}"></sidebar-item>
        <sidebar-item v-if="!isRole('Commercial') " :link="{ name: 'Administration FNC', icon: 'fa-solid fa-user-gear', path: '/fnc/admin'}"/>

        <sidebar-item v-if="stateByCommandType !== null" opened :link="{ name: 'Reporting', icon: 'fas fa-chart-line'}">
          <sidebar-item :link="{ name: 'FNC', path: '/reporting/fnc'}"></sidebar-item>
          <sidebar-item :link="{ name: 'Anomalies', path: '/reporting/anomalies'}"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-if="isRole('Admin') || (stateByCommandType !== null && isRole('Créateur'))" :link="{ name: 'Administration', icon: 'fa fa-gears'}">
          <sidebar-item :link="{ name: 'Liste des clients', path: '/customers/list'}"/>
          <sidebar-item :link="{ name: 'Liste des articles', path: '/articles/list'}"/>
          <sidebar-item :link="{ name: 'Liste des metadatas', path: '/metadatas/list'}"/>
          <sidebar-item v-if="isRole('Admin')" :link="{ name: 'Gestion des comptes', path: '/users/list'}"/>
          <sidebar-item :link="{ name: 'Migration Process v1', path: '/migration/form'}"/>
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <sidebar-share
        :color.sync="sidebarBackground"
        :fixed-navbar.sync="fixedNavbar"
        :sidebarMini.sync="sidebarMini"
        style="cursor: pointer"
      >
      </sidebar-share>
      <router-view name="header"></router-view>

      <div :class="{ content: !$route.meta.hideContent, 'content--compact-header': $route.meta.compactHeader }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import UserMenu from "./Extra/UserMenu.vue";
import { SlideYDownTransition, ZoomCenterTransition } from "vue2-transitions";
import Vuex from "vuex";
import SidebarShare from "./Extra/SidebarSharePlugin";
import authorizable from "@/mixins/authorizable";

export default {
  mixins: [
      authorizable
  ],
  components: {
    TopNavbar,
    ContentFooter,
    UserMenu,
    ZoomCenterTransition,
    SidebarShare,
  },
  data() {
    return {
      stateByCommandType: null,
      sidebarBackground: "black",
      fixedNavbar: false,
      sidebarMini: false,
      halloweenEnabled: window.localStorage.getItem('process-halloween-theme') !== 'off',

      isLoaded: false
    };
  },
  mounted() {
    let docClasses = document.body.classList;
    let isWindows = navigator.platform.startsWith("Win");
    if (isWindows) {
      // if we are on windows OS we activate the perfectScrollbar function
      initScrollbar("sidebar");
      initScrollbar("sidebar-wrapper");

      docClasses.add("perfect-scrollbar-on");
    } else {
      docClasses.add("perfect-scrollbar-off");
    }
    this.initScrollbar()
    // this.$store.dispatch("profile/me");

    this.fetchData()

    EventBus.$on('refreshFiltersNumbers', args => {
      this.fetchData()
    })
  },
  computed: {
    isCommandListRoute() {
      return /^\/commands\/(M4|WILINE|Horaflex|SpeedControl|checkbox|Proxy|Software|WIFI)$/i.test(this.$route.path);
    },
    isRecordListRoute() {
      return ['/fnc/list', '/product-documentations/list'].includes(this.$route.path) ||
        /^\/anomalies\/list(?:\/[^/]+)?$/.test(this.$route.path);
    },
    halloweenEligible() {
      return this.$route.path === '/dashboard' || this.isCommandListRoute || this.isRecordListRoute;
    },
    halloweenActive() {
      return this.halloweenEligible && this.halloweenEnabled;
    },
    ...Vuex.mapState({
      me: (state) => state.profile.me,
    }),
  },
  watch: {
    sidebarMini() {
      this.minimizeSidebar();
    },
  },
  methods: {
    toggleHalloweenTheme() {
      this.halloweenEnabled = !this.halloweenEnabled;
      window.localStorage.setItem('process-halloween-theme', this.halloweenEnabled ? 'on' : 'off');
      window.dispatchEvent(new CustomEvent('process-halloween-theme-change', { detail: this.halloweenEnabled }));
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
        let text = this.$sidebar.isMinimized ? "activated" : "deactivated";
        this.$notify({ type: "info", message: `Sidebar mini ${text}...` });
      }
    },
    fetchData(){
      this.axios.get(process.env.VUE_APP_API_BASE_URL+`commands/status`).then( response => {
        this.stateByCommandType = response.data[0]
      })
    },
  },
};
</script>

<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.main-panel > .content.content--compact-header {
  margin-top: 0;
  padding-top: 60px;
}

.sidebar[data-color=black] .nav li.active > a:not([data-toggle=collapse]) i, .sidebar[data-color=black] .nav li.active > a:not([data-toggle=collapse]) .sidebar-mini-icon, .off-canvas-sidebar[data-color=black] .nav li.active > a:not([data-toggle=collapse]) i, .off-canvas-sidebar[data-color=black] .nav li.active > a:not([data-toggle=collapse]) .sidebar-mini-icon {
  color: #f96332;
  z-index: 1;
}
.sidebar[data-color=black] .nav li.active > a:not([data-toggle=collapse]), .off-canvas-sidebar[data-color=black] .nav li.active > a:not([data-toggle=collapse]) {
  color: #f96332;
}
</style>
